export * from "modules/DMSv3/Settings/components/DMSv3SettingsTable/components/DMSv3LocationsTable";
